export default __webpack_public_path__ + "static/media/diamond.0464e4f3.png";